/**
 * Where the platform's legal documents live, for every link the app shows.
 *
 * They are published on onxite.com (ox-web, `src/content/legal/*.md`), the
 * same pages xotski.com's footer points to. xotski.com itself has NO
 * /terms or /privacy routes: a link there lands on the site's raw
 * "Unexpected Application Error · 404 Not Found" screen, which is exactly
 * what a user reported from the sign-up form on 12 Oct 2026.
 *
 * Note for anyone checking these with curl: onxite.com is static hosting
 * with no deep-link rule, so the URLs answer 404 to curl but render the
 * document in a browser (the SPA shell is the error page).
 */
export const LEGAL_LINKS = {
  terms: 'https://www.onxite.com/terms-conditions',
  privacy: 'https://www.onxite.com/privacypolicy',
  dataDeletion: 'https://www.onxite.com/data-deletion',
} as const;
